import { axiosAPIUrl, Parameter } from '@/api/index'
// import { ShopGoodsListDto } from '@/api/shoppingMall'
import { StoreDtlOTD } from '@/views/industryMall/shop/shop'
export class ShopGoodsInfoDto {
	/** 商品编号 */
	goodsId?: string
	goodsName?: string
	goodsCode?: string
	imageNameUrl?: string
	activityPriceMin?: string
	activityPriceMax?: string
	goodsPriceMax?: string // 商品价格最高价
	goodsPriceMin?: string // 商品价格最低价
	goodsStatus?: number
	isMultiSpec?: number | boolean
	goodsSellCount?: number
	categoryId?: string
	categoryName?: string
	keyword?: string
	createTime?: string
	updateTime?: string
	storeId?: string
	goodsMainImage?: string
	packageCount?: number
	goodsPrice?: number
	goodsCount?: number
	imageUrl?: string
	packageList?: PackageListDto[]
  goodsPackageList?: PackageListDto[] // 商城模块用到
	urlBase?: string
	finalPrice?: number
  isAddTag?: number // 是否添加标签(0不添加 1添加)
  tagName?: string // 标签内容
  tagColor?: string // 标签颜色
  activityId?: string // 活动id
}
export class PackageListDto {
	packageId?: string
	packageName?: string
	packageNameDesc?: string
	sellUnit?: number
	sellUnitWay?: string
	goodsCount?: number
	packageCode?: string
	mainImageUrl?: string
	mainImageSize?: number
	marketPrice?: string
  	finalPrice?:string
	weight?: number
	goodsSellCount?: number
	activityPrice?: string
	activityName?: string
	activityBeginTime?: string
	activityEndTime?: string
	activityDiscount?: string
	activityId?: string
	orderQuantity?: number | undefined
  packageStatus?: number // 套餐状态：商城模块用到 1：已上架 2：未上架
  goodsId?: string
	levelPriceList: any[]
}

/* 获取预提交订单信息入参数据类型 */
export class GetPreOrderInfoParamsDto {
	/* 操作人所属公司 */
	buyCustomerId?: string
	/* 合作方id */
	partnerCompanyId?: string
	/* 标注位 是否是由购物车提交的订单 默认否false */
	cartFlag?: boolean
	/* 收货地址 */
	receiveAddress?: string
	/* 收获地址明细 */
	receiveAddressDtl?: string
	/* 收货人手机 */
	receiveMobile?: string
	/* 收货人 */
	receiveMan?: string
	// 【待下单】店铺分组清单
	storeList?: PreShopPackageListDto[]
  companyId?:string
  distributionWay?: number
}

export class PreShopPackageListDto {
	/* 卖方 店铺Id */
	storeId?: string
	/* 商品总数 */
	goodsCount?: string
	/* 商品总价 */
	goodsAllPrice?: string
	/* 备注 */
	orderRemark?: string
	/* 【待下单】店铺下商品清单 */
	goodsPackageList?: PreGoodsPackageListDto[]
  /* 配送方式 */
  distributionWay?: number
  // 送货上门时间配置
  sendConfig?: any
  // 站点自提详细配置
  pickupConfig?: any
  // 站点自提时间配置
  pickupTimeConfig?: any
}

export class PreGoodsPackageListDto {
	/* 商品编号 */
	goodsId?: string
	/* 套餐编号 */
	packageId?: string
	/* 订购数量 */
	orderQuantity?: number
}

/* 购物车列表数据类型 */
export class BuyCarListDto {
	storeId?: string
	storeName?: string
	storeLogo?: string
	/* 是否已选中 */
	isChecked?: boolean
  /* 是否显示剩余的无效商品 -1：显示收起 0：不显示 1：显示展开 */
  showMore?: number
	/* 商品套餐清单 */
	goodsPackageList?: BuyCarPackageListDto[]
}
export class BuyCarPackageListDto extends ShopGoodsInfoDto {
	autoId?: string
	isChecked?: boolean
	isEdit?: boolean
  isHidden?: boolean // 是否隐藏
	isValid?: number
	orderQuantity?: number
	packageId?: string
	packageMainImage?: string
	packageName?: string
	packageNameDesc?: string
  sellUnit!: string
}
export class PreOrderInfoListDto {
	goodsAllPrice?: number
	storeList?: any[]
}

export class CategoryListDTO {
	storeId?: string
	categoryId?: string
	categoryName?: string
	hierarchyId?: string
	categoryLevel?: string
	children?: CategoryListDTO[]
	parentId?: string
}
export type PartnerCategoryList = {
	// 分类列表
	categoryList?: PartnerCategoryList[]
	// 分类编号
	categoryId?: string
	// 分类名称
	categoryName?: string
	// 层级编号
	hierarchyId?: string
	// 分类层级
	categoryLevel?: string
	// 上级分类
	parentId?: string
	// 是否使用
	isUse?: boolean
	children?: PartnerCategoryList[]
}

export class StoreListDTO {
	storeId?: string
	storeName?: string
	storeInfo?: string
	logoUrl?: string
	storeBackgroundImageUrl?: string
	companyCode?: string
	goodsList?: ShopGoodsInfoDto[]
}

// 送货上门最低金额配置
export class MinConfigDto {
  storeId!: string;
  minDeliverGoodsStatus!: number; //  0:关闭送货上门最低金额,1:打开最低金额设置
  minDeliverGoodsMoney?: number; // 送货上门最低金额
}

// 上门配置日期配置
export class SendGoodsTimeDto {
  storeId!: string;
  openTip!: number; //  0:关闭 1:打开
  sendStartTime?: number; // // 配送开始时间 M
  sendEndTime?: number; // 配送结束时间 N
  predictTime?: string; // 预计送达时间
  lastBuyTime?: string; // 每天配送最迟下单时间 C
}

// 站点自提配置
export class PickupConfigDto {
  storeId!: string;
  pickupStartTime!: number; // 自提开始时间 M
  pickupEndTime!: number; // 自提结束时间 N
  lastBuyTime!: string; // 每天配送最迟下单时间 C
}

// 站点自提详细配置
export class PickupDetailDto {
  pickupId!: string; // 自提点编号
  storeId!: string; // 店铺编号
  pickupName?: string; // 自提点名称
  pickupAddress?: string; // 自提点地址
  pickupLongitude?: number; // 精度
  pickupLatitude?: number; // 纬度
  pickupLinkman?: string; // 联系人
  pickupMobile?: string; // 联系方式
  pickupStartTime?: string; // 营业开始时间
  pickupEndTime?: string; // 营业结束时间
  isUse!: number; // 是否使用（0：删除1：使用）
  pickupStatus!: string; // 1:开启 0：否
}

export class ActivityDTO {
  storeId?: string
  storeName?: string
  storeInfo?: string
  logoUrl?: string
  storeBackgroundImageUrl?: string
  companyCode?: string
  goodsList?: ShopGoodsInfoDto[]
}

/* ------------------客户运营模块-------------------- */
/**
 * @description 9.5 获取产业商城信息(getStoreDtl)
 * @param parameter
 */
export function getStoreDtl(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<StoreDtlOTD>>({
		url: '/cykjoperation/storeQuery/getStoreDtl',
		method: 'post',
		data: parameter,
		extraParams: { showLoading: false },
	})
}
/**
 * @description 9.15 获取产业商城信息(getStoreDtlBy)—有是否关注
 * @param parameter
 */
export function getStoreDtlBy(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<StoreDtlOTD>>({
		url: '/cykjoperation/storeQuery/getStoreDtlBy',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}
/**
 * @description 9.6 判断产业商城是否停用(getStoreIsUse)
 * @param storeId
 */
export function getStoreIsUse(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjoperation/storeQuery/getStoreIsUse',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}
/**
 * @description 9.12 关注产业商城店铺(followStore)
 * @param storeId
 */
export function followStore(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjoperation/storeQuery/followStore',
		method: 'post',
		data: parameter,
	})
}

/**
 * @description 9.13 取消关注产业商城店铺(cancelFollowStore)
 * @param storeId
 */
export function cancelFollowStore(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjoperation/storeQuery/cancelFollowStore',
		method: 'post',
		data: parameter,
	})
}

/**
 * @description 9.14 获取关注店铺列表(getFollowStoreList)
 * @param storeId
 */
export function getFollowStoreList(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
		url: '/cykjoperation/storeQuery/getFollowStoreList',
		method: 'get',
		params: parameter,
    extraParams: { showLoading: false }
	})
}

/* ------------------商城模块----------------------- */
export function getCyStoreActivityGoodsList(params: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response>({
		url: '/cykjStore/GetGoodsInfo/getCyStoreActivityGoodsList',
		method: 'get',
		params: { ...params },
		extraParams: { showLoading: false },
	})
}
/**
 * 1.3 商城 获取商品列表(getCyStoreGoodsList)
 * @param parameter
 */
export function getCyStoreGoodsList(parameter: Parameter = {}, showLoading = false) {
	return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopGoodsInfoDto>>>({
		url: '/cykjStore/GetGoodsInfo/getCyStoreGoodsList',
		method: 'get',
		params: parameter,
    extraParams: { showLoading }
	})
}

/**
 * @description 1.4 获取商品详情(getCyStoreGoodsDtl)
 * @param storeId
 * @param goodsId
 */
export function getCyStoreGoodsDtl(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<ShopGoodsInfoDto>>({
		url: '/cykjStore/GetGoodsInfo/getCyStoreGoodsDtl',
		method: 'get',
		params: parameter,
    extraParams: { showLoading: false }
	})
}

/**
 * @description 1.5 获取商品规格列表(getCyGoodsSpecificationList)
 * @param storeId
 * @param goodsId
 */
export function getCyGoodsSpecificationList(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/GetGoodsInfo/getCyGoodsSpecificationList',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}

/**
 * @description 1.6 判断商品是否上架(isGoodsValid)
 * @param storeId
 * @param goodsId
 */
export function isGoodsValid(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/GetGoodsInfo/isGoodsValid',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}
/**
 * @description 1.7 获取合作方下产业商城分类(getGoodsCategoryList)
 * @param partnerCompanyId 合作方企业编号 二传一
 * @param storeId 店铺编号 二传一
 */
export function getGoodsCategoryList(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/GetGoodsInfo/getGoodsCategoryList',
		method: 'get',
		params: parameter,
	})
}
/**
 * @description 1.8 1.8 获取合作方下产业商城分类-新(getPartnerCategoryList)
 * @param partnerCompanyId 合作方企业编号 二传一
 * @param storeId 店铺编号 二传一
 */
// export function getPartnerCategoryList(parameter: Parameter = {}) {
// 	return axiosAPIUrl<Ajax.ArrayResponse<PartnerCategoryList>>({
// 		url: '/cykjStore/GetGoodsInfo/getPartnerCategoryList',
// 		method: 'get',
// 		params: parameter,
// 	})
// }
/**
 * @description 1.8 获取合作方下产业商城分类-新(getPartnerCategoryList)
 * @param partnerCompanyId 合作方企业编号 二传一
 * @param storeId 店铺编号 二传一
 */
export function getPartnerCategoryList(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.ArrayResponse<PartnerCategoryList>>({
		url: '/channelPartner/PGC/getGoodsCategoryList',
		method: 'post',
		data: parameter,
	})
}

/**
 * @description 1.9 获取商品与店铺数据(getGoodsOrStoreCount)
 */
export function getGoodsOrStoreCount(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/GetGoodsInfo/getGoodsOrStoreCount',
		method: 'get',
		params: parameter,
	})
}
/**
 * @description 1.10 搜索店铺(getStoreList)
 */
export function getStoreList(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/GetGoodsInfo/getStoreList',
		method: 'get',
		params: parameter,
	})
}

/**
 * @description 2.1 加入购物车(addStoreShoppingCart)
 * @param storeId - 店铺编号(公司编号)
 * @param goodsId - 商品编号
 * @param partnerCompanyId - 合作方id
 * @param {string} packageId - 套餐编号
 * @param {string} orderQuantity - 订购数量
 */
export function addStoreShoppingCart(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/ShoppingCart/addStoreShoppingCart',
		method: 'post',
		data: parameter,
		extraParams: { showLoading: false },
	})
}
/**
 * @description 2.7 SC007-批量加入购物车 batchAddStoreShoppingCart
 * @param storeId - 店铺编号(公司编号)
 * @param goodsId - 商品编号
 * @param partnerCompanyId - 合作方id
 */
export function batchAddStoreShoppingCart(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/ShoppingCart/batchAddStoreShoppingCart',
		method: 'post',
		data: parameter,
		extraParams: { showLoading: false },
	})
}
/**
 * @description 2.2 获取购物车商品数量(getStoreShoppingCartCount)
 * @param partnerCompanyId - 合作方id
 */
export function getStoreShoppingCartCount(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/ShoppingCart/getStoreShoppingCartCount',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}

/**
 * @description 2.3 更新购物车(updateStoreShoppingCart)
 * @param partnerCompanyId - 合作方id
 * @param storeId - 店铺编号(公司编号)
 * @param goodsId - 商品编号
 * @param packageId - 套餐编号
 * @param orderQuantity - 订购数量
 */
export function updateStoreShoppingCart(parameter: Parameter = {} , showLoading = false) {
	return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
		url: '/cykjStore/ShoppingCart/updateStoreShoppingCart',
		method: 'post',
		data: parameter,
    	extraParams: { showLoading }
	})
}

/**
 * @description 2.4 移出购物车(batchDelStoreShoppingCart)
 * @param <autoIdList>
 * @param autoId
 */
export function batchDelStoreShoppingCart(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
		url: '/cykjStore/ShoppingCart/batchDelStoreShoppingCart',
		method: 'post',
		data: parameter,
	})
}

/**
 * @description 2.5 获取购物车中商品列表(getStoreShoppingCart)
 * @param partnerCompanyId - 合作方id
 * @param pageSize
 * @param pageIndex
 */
export function getStoreShoppingCart(parameter: Parameter = {}, showLoading = false) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjStore/ShoppingCart/getStoreShoppingCart',
		method: 'post',
		data: parameter,
    extraParams: { showLoading }
	})
}

/*----------------- 订货单管理（OM）---------------------- */
/**
 * @description 1.1 立即下单(getAdvanceOrder)
 */
export function getAdvanceOrder(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/OM/getAdvanceOrder',
		method: 'post',
		data: parameter,
	})
}

//
/**
 * @description 1.2 提交订单(submitStoreOrder)
 * @param parameter
 */
export function submitStoreOrder(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/OM/submitStoreOrder',
		method: 'post',
		data: parameter,
	})
}

/**
 * @description 1.6 获取不同状态的订货数量(getStoreOrderCount)
 * @param partnerCompanyId 合作方公司id
 */
export function getStoreOrderCount(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<{ orderStatus?: string; orderCount: number }[]>>({
		url: '/StoreOrder/OM/getStoreOrderCount',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}

/**
 * @description 1.9 客户获取订单(getStoreOrder)
 * @param partnerCompanyId 合作方公司id
 * @param pageSize
 * @param pageIndex
 */
export function getStoreOrder(parameter: Parameter = {}, config = {}) {
	return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
		// url: "/StoreOrder/OM/getStoreOrder",
		url: '/StoreOrder/SYTS/getStoreOrder', //小研发接口
		method: 'get',
		params: parameter,
		...config,
	})
}

/**
 * @description 1.10 客户取消订货单(cancelStoreOrder)
 * @param orderId 订单编号id
 * @param orderRemark 备注
 */
export function cancelStoreOrder(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
		url: '/StoreOrder/OM/cancelStoreOrder',
		method: 'post',
		data: parameter,
	})
}
/**
 * @description 1.11 客户确认收货(cusStockInStoreOrder)
 * @param storeId
 * @param orderId
 */
export function cusStockInStoreOrder(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/OM/cusStockInStoreOrder',
		method: 'post',
		data: parameter,
	})
}
/**
 * @description 1.12 再次购买(storeGoodsAgain)
 * @param {string} storeId
 * @param {string} orderId
 */
export function storeGoodsAgain(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/OM/storeGoodsAgain',
		method: 'post',
		data: parameter,
		extraParams: { showLoading: false },
	})
}

/**
 * @description 1.13 客户获取订单详情(getStoreOrderDtl)
 * @param orderId 订单编号
 */
export function getStoreOrderDtl(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		// url: "/StoreOrder/OM/getStoreOrderDtl",
		url: '/StoreOrder/SYTS/getStoreOrderDtl', //小研发接口
		method: 'get',
		params: parameter,
	})
}

/* -----------------------退货单管理-------------------------- */

//
/**
 * @description 2.3 判断订货单是否可以退单（getStoreOrderCanReturn）
 * @param orderId
 * @param storeId
 */
export function getStoreOrderCanReturn(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/ORM/getStoreOrderCanReturn',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}
/**
 * @description 2.4 客户发起退货（launchStoreReturnOrder）
 * @param parameter
 */
export function launchStoreReturnOrder(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/ORM/launchStoreReturnOrder',
		method: 'post',
		data: parameter,
	})
}

/**
 * @description 2.11 客户获取可退商品列表（getReturnOrderGoods）
 * @param parameter
 */
export function getReturnOrderGoods(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/ORM/getReturnOrderGoods',
		method: 'get',
		params: parameter,
	})
}

/**
 * @description 2.12 客户获取退单(getStoreReturnOrder)
 * @param partnerCompanyId 合作方公司编号
 */
export function getStoreReturnOrder(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/ORM/getStoreReturnOrder',
		method: 'get',
		params: parameter,
	})
}

/**
 * @description 2.13 客户取消退货 (cancelStoreReturnOrder)
 * @param returnOrderId
 */
export function cancelStoreReturnOrder(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/ORM/cancelStoreReturnOrder',
		method: 'post',
		data: parameter,
	})
}

/**
 * @description 2.14 客户获取退单详情(getStoreReturnOrderDtl)
 * @param returnOrderId
 */
export function getStoreReturnOrderDtl(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/ORM/getStoreReturnOrderDtl',
		method: 'get',
		params: parameter,
	})
}

/* -----------------------订货单设置-------------------------- */

/**
 * @description 4.1 获取产业商城订货/退货处理流程 (getStoreOrderNodeList)
 * @param orderId 订单编号/退单编号
 * @param type 订货/退货
 */
export function getStoreOrderNodeList(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/OrderSet/getStoreOrderNodeList',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false }
	})
}
/**
 * @description 4.2 获取操作节点日志（getStoreOrderOperateLog）
 * @param orderId 订单编号/退单编号
 * @param storeId 店铺编号
 * @param isReturn 是否是退货单
 * @param isValid 是否有效
 */
export function getStoreOrderOperateLog(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/StoreOrder/OrderSet/getStoreOrderOperateLog',
		method: 'post',
		data: parameter,
		extraParams: { showLoading: false }
	})
}

/**
 * @description 4.7 获取送货上门最低金额设置（getMinDeliverGoods）
 * @param storeId 店铺编号
 */
export function getMinDeliverGoods(parameter: Parameter = {}, showLoading = false) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/StoreOrder/OrderSet/getMinDeliverGoods',
    method: 'get',
    params: parameter,
    extraParams: { showLoading }
  })
}

/**
 * @description 4.8 获取自提点设置列表(getPickupConfig)
 * @param storeId 店铺编号
 */
export function getPickupConfig(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/StoreOrder/OrderSet/getPickupConfig',
    method: 'post',
    data: parameter,
    extraParams: { showLoading: false }
  })
}

/**
 * @description 4.17 获取送货上门配置日期 getSendGoodsTime
 * @param storeId 店铺编号
 */
export function getSendGoodsTime(parameter: Parameter = {}, showLoading = false) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/StoreOrder/OrderSet/getSendGoodsTime',
    method: 'get',
    params: parameter,
    extraParams: { showLoading }
  })
}

/**
 * @description 4.19 获取站点自提日期设置 getPickupGoodsTime
 * @param storeId 店铺编号
 */
export function getPickupGoodsTime(parameter: Parameter = {}, showLoading = false) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/StoreOrder/OrderSet/getPickupGoodsTime',
    method: 'get',
    params: parameter,
    extraParams: { showLoading }
  })
}

/**
 * @description 4.21 客户查询自提点
 * @param storeId 店铺编号
 */
export function getSelfPickupPoint(parameter: Parameter = {}, showLoading = false) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/StoreOrder/OrderSet/getSelfPickupPoint',
    method: 'get',
    params: parameter,
    extraParams: { showLoading }
  })
}

// <-------------------------- 业务操作日志 -------------------->
/**
 * @description 3.1 新增产业商城搜索框历史记录(addStoreSearchHistory)
 * @param searchType 类型
 * @param keyword 搜索关键字
 * @param providerId 店铺编号
 * @param customerId 客户编号
 */
export function addStoreSearchHistory(parameter: Parameter = {}) {
	console.log('data------', parameter)
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjbusiness/SM/addStoreSearchHistory',
		method: 'post',
		data: parameter,
		extraParams: { showLoading: false }
	})
}
/**
 * @description 3.2 删除产业商城搜索框历史记录(clearStoreSearchHistory)
 * @param searchType 类型
 * @param providerId 店铺编号
 */
export function clearStoreSearchHistory(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjbusiness/SM/clearStoreSearchHistory',
		method: 'post',
		data: parameter,
	})
}
/**
 * @description 3.3 获取产业商城搜索框历史记录列表(getStoreSearchHistoryList)
 * @param searchType 类型
 * @param providerId 店铺编号
 */
export function getStoreSearchHistoryList(parameter: Parameter = {}) {
	return axiosAPIUrl<Ajax.Response<any>>({
		url: '/cykjbusiness/SM/getStoreSearchHistoryList',
		method: 'get',
		params: parameter,
		extraParams: { showLoading: false },
	})
}

/************************************* 广告相关 ****************************/
// 4.1 HP001-获取是否展示列表 getIsShowList
export function getIsShowList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/HomePageLayout/getIsShowList',
    method: 'get',
    params: parameter
  })
}

// 4.2 HP002-获取轮播广告列表 getBannerImageList
export function getBannerImageList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Array<any>>>({
    url: '/cykjStore/HomePageLayout/getBannerImageList',
    method: 'get',
    params: parameter
  })
}

// 4.3 HP003-获取图标导航列表 getIconNavigationList
export function getIconNavigationList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Array<any>>>({
    url: '/cykjStore/HomePageLayout/getIconNavigationList',
    method: 'get',
    params: parameter
  })
}

// 4.4 HP004-获取活动商品详情 getActivityGoodsList
export function getActivityGoodsList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjStore/HomePageLayout/getActivityGoodsList',
    method: 'get',
    params: parameter
  })
}

// 4.5 HP005-获取活动详情商品列表 getActivityDtlGoodsList
export function getActivityDtlGoodsList (parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<Ajax.ListData<any>>>({
    url: '/cykjStore/HomePageLayout/getActivityDtlGoodsList',
    method: 'get',
    params: parameter
  })
}
